import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Game } from '../../../Core'

import * as savePointActions from '../../SavePoint/savePoint.actions'

/**
 *  The bed.
 */
class ChangeTurn extends React.Component {
  /**
   *  On click handler.
   */
  onClick() {
    const { startTurnChange } = this.props
    startTurnChange()
  }

  /**
   *  Render the compon0ent
   */
  render() {
    const props = {
      ...this.props,
      onClick: () => {
        this.onClick()
      },
    }

    return <Game.SceneObject {...props} />
  }
}

ChangeTurn.propTypes = {
  startTurnChange: PropTypes.func,
}

const mapStateToProps = () => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return {
    startTurnChange: bindActionCreators(savePointActions.startTurnChange, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeTurn)
